import PropTypes from 'prop-types';
import classNames from 'classnames';
import React from 'react';
import ProgramLink from '../components/menu-bar/program-link.jsx';
import { FormattedMessage } from 'react-intl';

/*
todo : 国际化
开发环境 React Intl 会警告⚠️，无碍。
需在 Scratch-I10n/locales/interface-msgs.js 添加相关字段。
*/
const linkMessages = {
    myWork: {
        messages: {
            defaultMessage: "我的作品",
            description: "學生的作品展示",
            id: "gui.menuBar.myWork"
        },
        programLink: `${location.origin}/customer-center/myProject.html?t=${Date.now()}`
    },
    goHome: {
        messages: {
            defaultMessage: "回到官網",
            description: "編程官網首頁",
            id: "gui.menuBar.goHome"
        },
        programLink: `${location.origin}/`
    }
}

class ProgramLinkGroup extends React.Component {
    render() {
        const { className } = this.props;
        return (
            <React.Fragment>
                <ProgramLink className={classNames(className)} programLink={linkMessages.myWork.programLink}>
                    <FormattedMessage
                        defaultMessage="我的作品"
                        description="學生的作品展示"
                        id="gui.menuBar.myWork"
                    />
                </ProgramLink>
                <ProgramLink className={classNames(className)} programLink={linkMessages.goHome.programLink}>
                    <FormattedMessage
                        defaultMessage="回到官網"
                        description="官網主頁"
                        id="gui.menuBar.goHome"
                    />
                </ProgramLink>
            </React.Fragment>
        )
    }
}

ProgramLinkGroup.propTypes = {
    className: PropTypes.string
}

export default ProgramLinkGroup;
